import { Typography } from '@mui/material';

export default function NotFound() {
  return (
    <Typography variant="h4">
      De pagina die je hebt gevraagd bestaat niet ...
    </Typography>
  );
}
